import React, {useContext, useState} from 'react';
import CheckboxInput from "../../../../Inputs/CheckboxInput/CheckboxInput";
import {useHttp} from "../../../../../hooks/http.hook";
import {AuthContext} from "../../../../../context/AuthContext";


function CheckboxCell({payed, updateUrl}) {
    const {request} = useHttp()
    const {token} = useContext(AuthContext)
    const [checked, setChecked] = useState(payed)
    const baseURL = process.env.REACT_APP_BASE_URL

    const getData = async () => {
        const url = `${baseURL}${updateUrl}`
        const {data} = await request(url, 'PUT', null, {Authorization: `Bearer ${token.token}`})
        setChecked(data.data.payed)
    }

    const clickHandler = () => {
        getData()
    }

    return (
        <div className='row__cell' onClick={clickHandler}>
            <CheckboxInput checked={checked}/>
        </div>
    );
}

export default CheckboxCell;
